export default ngModule => {

  ngModule.directive('debugOverlay', () => {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
          packages: '=',
      },
      template: require("../partials/debug-overlay.html"),
      link: (scope, element, attrs) => {
          $(element).addClass('debug-overlay');
          $(element).click( () => {
             $(element).find('.debug-inner').toggleClass('open');
          });
      }
    }
  });

}



// WEBPACK FOOTER //
// ./src/directives/debug-directives.js